// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3cjCu","title":"ClientReferral_title__1eUEU","itemText":"ClientReferral_itemText__3CaUw"};